import { IconInformationSmall } from '@amzn/stencil-react-icons';

import { TooltipTrigger } from '../TooltipTrigger';

export interface InfoTooltipProps {
  /** The help text shown in the tooltip. */
  readonly text: string;
  /** Accessible label for the icon trigger (e.g. "More information"). */
  readonly ariaLabel: string;
  readonly dataTestId?: string;
}

/**
 * A small "ⓘ" info icon that reveals `text` in a Stencil tooltip on
 * hover/focus. Site-wide affordance for field-level help next to a form
 * label — pairs with `RequiredLabel` in a label row. Built on the shared
 * {@link TooltipTrigger}; `aria-label` on the `img` trigger makes it
 * discoverable to assistive tech.
 */
export function InfoTooltip({
  text,
  ariaLabel,
  dataTestId,
}: InfoTooltipProps): JSX.Element {
  return (
    <TooltipTrigger
      text={text}
      ariaLabel={ariaLabel}
      role="img"
      {...(dataTestId !== undefined ? { dataTestId } : {})}
    >
      <IconInformationSmall aria-hidden="true" />
    </TooltipTrigger>
  );
}
